import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import React from 'react';
import { Skeleton } from '@mui/material';

const CellarCardLoading = (): JSX.Element => (
    <Card className="cellar-card cellar-card-loading" elevation={1}>
        <CardContent>
            <Skeleton variant="text" sx={{ fontSize: '2rem' }} width={80} />
            <Skeleton
                variant="text"
                sx={{ fontSize: '1rem', mt: '2rem' }}
                width={80}
            />
            <Skeleton
                variant="rectangular"
                sx={{ marginTop: '2rem', ml: '1rem' }}
            />
            <Skeleton
                variant="text"
                sx={{ marginTop: '2rem', ml: '1rem' }}
                width={60}
            />
        </CardContent>
    </Card>
);

export default CellarCardLoading;
